import { ValueError } from "@moment/design-system/ValueError";
import { ButtonAlpha } from "@moment/design-system/canvas-components/ButtonAlpha";
import { DataGridAlphaV3 } from "@moment/design-system/canvas-components/DataGridAlphaV3";
import { InputTextAlpha } from "@moment/design-system/canvas-components/InputTextAlpha";
import { ReactionAlpha } from "@moment/design-system/canvas-components/ReactionAlpha";

import { BaseView } from "~/ui/BaseView";
import { LinkButton as LinkButtonAlphaV2 } from "~/ui/Button";

import { ButtonAlphaV2 } from "./ui/ButtonAlphaV2";

export const designSystem = {
	ValueErrorAlpha: ValueError,
	BaseView,
	ButtonAlpha,
	ButtonAlphaV2,
	LinkButtonAlphaV2,
	InputTextAlpha,
	DataGridAlphaV3,
	ReactionAlpha,
};
